module.exports = __webpack_public_path__ + "static/media/agentopolis_screenshot.0c8acd9a.webp";